/**
 * useTipJarInjector Hook
 * 
 * Handles runtime DOM injection of the TipJar component into SystemMenu.
 * Runs after React hydration to avoid conflicts with React's virtual DOM.
 * 
 * Usage:
 *   useTipJarInjector({ onTipSubmit: (amount) => console.log(`Tip: $${amount}`) });
 */

import { useEffect, useRef } from 'react';
import { injectTipJar, TipJarConfig } from '@/components/TipJar';

export function useTipJarInjector(config: TipJarConfig = {}) {
  const injectionAttempted = useRef(false);

  useEffect(() => {
    // Prevent multiple injection attempts
    if (injectionAttempted.current) return;
    injectionAttempted.current = true;

    // Wait for DOM to be fully ready (next tick)
    const timeoutId = setTimeout(() => {
      try {
        const success = injectTipJar(config);
        if (success) {
          console.log('[useTipJarInjector] TipJar injection successful');
        }
      } catch (error) {
        console.error('[useTipJarInjector] Unexpected error during injection:', error);
      }
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [config]);
}
